import { createUrlParameters } from './url-params.js';

const getUrl = (url, data) => {
	const API_BASE_PATH = process.env.API_BASE_PATH || '';
	if (data === undefined) {
		return `${API_BASE_PATH}${url}`;
	}
	return `${API_BASE_PATH}${url}?${createUrlParameters(data)}`;
};

const fetchJson = async (url, data, opts = {}) => {
	const headers = new Headers();
	headers.append('accept', 'application/json');
	const options = {
		headers,
		method: 'GET',
		credentials: 'include',
		cache: 'no-store',
		...opts
	};

	const response = await fetch(getUrl(url, data), options);

	if (response.ok) {
		return response.json();
	}
	if (response.status === 404) {
		return {};
	}
	return { message: response };
};

function sendJson(url, data, httpMethod) {
	const headers = new Headers();
	const API_BASE_PATH = process.env.API_BASE_PATH || '';

	headers.append('Content-Type', 'application/json');
	const options = {
		headers,
		method: httpMethod,
		mode: 'cors',
		cache: 'default',
		credentials: 'include',
		body: JSON.stringify(data)
	};

	return fetch(`${API_BASE_PATH}${url}`, options)
		.then(response => {
			if (response.status === 204) {
				return undefined;
			}
			return response.json();
		})
		.catch(e => {
			// eslint-disable-next-line no-console
			console.log(`${e} for ${httpMethod} ${url}`);

			return Promise.reject(e);
		});
}
function postJson(url, data) {
	return sendJson(url, data, 'POST');
}

function putJson(url, data) {
	return sendJson(url, data, 'PUT');
}

export { fetchJson, postJson, putJson };
